import IWallet from '../types';

declare global {
  interface Window {
    ethereum?: unknown;
  }
}

const MetaMask = (): IWallet => {
  const getProvider = () => {
    const provider = window.ethereum as any;
    if (!provider) {
      return false;
    }

    if (provider.providers?.length) {
      const foundProvider = provider.providers.find((p: any) => p.isMetaMask);
      if (foundProvider) {
        return foundProvider;
      }
    }

    if (provider.isMetaMask) {
      return provider;
    }

    return false;
  };

  const isProviderAvailable = (): boolean => {
    return !!getProvider();
  };

  const isEnabled = async (): Promise<boolean> => {
    if (!isProviderAvailable()) {
      return false;
    }

    const provider = getProvider();
    const accounts = await provider.request({ method: 'eth_accounts' });

    return accounts.length > 0;
  };

  const disconnect = async (_: any): Promise<void> => {
    // do nothing
  };

  return { isProviderAvailable, getProvider, isEnabled, disconnect };
};

export default MetaMask;
